const links = [
  {
    iconSrc: "/assets/images/home.svg",
    name: "home",
    href: "/",
    text: "view home page",
  },
  {
    iconSrc: "/assets/images/briefcase.svg",
    name: "projects",
    href: "/projects",
    text: "view projects",
  },
  {
    iconSrc: "/assets/images/contact.svg",
    name: "contact",
    href: "/contact",
    text: "contact",
  },
  {
    iconSrc: "/assets/images/info.svg",
    name: "about",
    href: "/about",
    text: "go to about page",
    external: undefined,
  },
  {
    iconSrc: "/assets/images/admin.svg",
    name: "admin",
    href: "/admin",
    text: "go to admin page",
    external: undefined,
  },
];

export default links;
